<app-view-item *ngIf="readonly" [text]="selected?.code" [tabindex]="tabindex"></app-view-item>
<div class="area-select-container" *ngIf="!readonly">
  <nz-select #selector nzShowSearch nzServerSearch [nzAllowClear]="nzAllowClear" [nzBackdrop]="addBackdrop"
    [nzFilterOption]="nzFilterOption" (nzOnSearch)="onSearch($event)" (nzOpenChange)="onDropdownOpenChange($event)"
    [nzCustomTemplate]="displayTpl" (nzScrollToBottom)="loadMore()" (keydown)="handleKeyDown($event)"
    (click)="handleClick($event)" [(ngModel)]="value" (ngModelChange)="valueChanged($event)"
    [nzDropdownMatchSelectWidth]="false" nzDropdownClassName="dropdownSelect" class="width-100" [nzOptionHeightPx]="60" [nzOptionOverflowSize]="4"
    [nzPlacement]="'bottomLeft'" [tabindex]="tabindex">
    <!-- [nzOptionHeightPx]="55" -->
    <ng-template #displayTpl let-selected>
      {{ selected.nzLabel }}
    </ng-template>
    <!-- Custom Add New Button at top -->
    <nz-option *ngIf="!searching && showAddNewButton" [nzValue]="''" nzCustomContent>
      <div class="text-center" *ngIf="!this.NotShowInReport">
        <button type="button" nz-button nzType="primary" class="add-new-button" (click)="$event.stopPropagation(); onAddNewClick($event)" [acl]="'area.create'">
          <span nz-icon nzType="plus"></span>
          {{ storedInstantData ? ' Add New \''+ storedInstantData +'\'' : ' Add New' }}
        </button>
      </div>
    </nz-option>

    <!-- OCR Suggested Items Section -->
    <ng-container *ngIf="!searching && ocrSuggested && ocrSuggested.length > 0">
      <!-- Suggested Label -->
      <nz-option [nzValue]="'__section_label__'" [nzLabel]="'Suggested'" nzDisabled nzCustomContent>
        <div class="section-label suggested-label">
          <span class="label-text">Suggested</span>
        </div>
      </nz-option>

      <!-- OCR Suggested Items -->
      <nz-option *ngFor="let suggestion of ocrSuggested" [nzValue]="'__ocr_suggested__' + suggestion"
        [nzLabel]="suggestion" nzCustomContent>
        <div class="ocr-suggested-item" (click)="onOcrSuggestedClick(suggestion, $event)">
          <span class="ocr-text">{{ suggestion }}</span>
        </div>
      </nz-option>
    </ng-container>

    <!-- Areas Section Label -->
    <ng-container *ngIf="!searching && list && list.length > 0 && ocrSuggested">
      <nz-option [nzValue]="'__section_label__'" [nzLabel]="'Areas'" nzDisabled nzCustomContent>
        <div class="section-label areas-label">
          <span class="label-text">Areas</span>
        </div>
      </nz-option>
    </ng-container>

    <ng-container *ngFor="let o of list">
      <nz-option *ngIf="!searching" [nzValue]="getValue(o)" [nzLabel]="getLabel(o)" nzCustomContent>
        <app-area-select-item [area]="o"></app-area-select-item>
      </nz-option>
    </ng-container>
  </nz-select>

  <!-- Inline Add Panel -->
  <app-inline-add-panel #inlineAddPanel [config]="areaConfig" [visible]="showInlineAddPanel"
    [initialData]="inlineDefaults" (itemCreated)="onAreaCreated($event)" (cancelled)="onAreaCancelled()"
    (visibleChange)="showInlineAddPanel = $event" (moreDetails)="onAreaMoreDetails()"
    (fieldChange)="onFieldChange($event)">
  </app-inline-add-panel>
</div>